export function daysBetweenDates(dateOld, dateNew) {
    const d1 = new Date(dateOld);
    const d2 = new Date(dateNew);
    const timeDifference = (d2.getTime() - d1.getTime()) / (1000 * 60 * 60 * 24);
    return Math.floor(timeDifference);
}
